/**
 * @author Gananath Athukorala
 * @version 0.1
 * @since 6/6/2023
 */

import React, { useState } from "react"
import "../styles/ProfileDropdown.styles.scss"
import labelsEN from "../../../../locales/en/translation.json"
import StorageService from "../../services/StorageService"
import Helpers from "../../utils/Helpers"
import BackgroundLetterAvatars from "./BackgroundLetterAvatars"
import {
  Box,
  IconButton,
  Tooltip,
  Divider,
  Typography,
  Grid,
  Stack,
} from "@mui/material"
import { AccountCircle, Logout } from "@mui/icons-material"

const MyProfileDetails = ({ handleMyProfile, logout }) => {
  const values = useState(StorageService.getUserData())
  const displayName =
    values[0].displayName === "-" ? values[0].firstName : values[0].displayName

  return (
    <div>
      <Box className="bgBox" />
      <div className="avaterPosition">
        <Box className="itemCenter" padding={2}>
          <BackgroundLetterAvatars displayName={displayName} />
        </Box>
      </div>
      <div className="userDetailsPosition">
        <Box
          component="ul"
          aria-labelledby="category-a"
          sx={{ pl: 2, padding: "0" }}>
          <h5>
            {values[0].displayName === "-"
              ? values[0].username
              : values[0].displayName}
          </h5>
          <p style={{ fontSize: "10px" }}>
            {Helpers.underscoreRoleFormat(values[0].userRole)}
          </p>
          <p className="pTagspacing">
            {values[0].primEmail === "-" ? null : values[0].primEmail}
          </p>
        </Box>
      </div>
      <Divider className="dividerPosition" />
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        divider={<Divider orientation="vertical" flexItem />}
        spacing={2}>
        <Tooltip title={labelsEN.app_header_menuItem_1}>
          <IconButton
            size="small"
            onClick={handleMyProfile}
            sx={{ borderRadius: 3 }}>
            <Grid container direction="column" sx={{ padding: "1px 15px" }}>
              <Grid item>
                <AccountCircle fontSize="large" />
              </Grid>
              <Grid item>
                <Typography variant="body2">
                  {labelsEN.app_header_menuItem_1}
                </Typography>
              </Grid>
            </Grid>
          </IconButton>
        </Tooltip>
        <Tooltip title={labelsEN.app_header_menuItem_2}>
          <IconButton size="small" onClick={logout} sx={{ borderRadius: 3 }}>
            <Grid container direction="column" sx={{ padding: "1px 15px" }}>
              <Grid item>
                <Logout fontSize="large" />
              </Grid>
              <Grid item>
                <Typography variant="body2">
                  {labelsEN.app_header_menuItem_2}
                </Typography>
              </Grid>
            </Grid>
          </IconButton>
        </Tooltip>
      </Stack>
    </div>
  )
}

export default MyProfileDetails
